import { ResponsiveLine } from '@nivo/line'
import { useMemo } from 'react'
import { getLineChartParams } from '../../components/customCharts/helpers'
import { CustomChart as CustomChartType } from '../../components/customCharts/types'
import { theme } from '../../constants'

export const CustomLineChart = ({
  chart,
  data,
}: {
  chart: CustomChartType
  data: any
}) => {
  const params = useMemo(() => getLineChartParams(chart, data), [chart, data])

  return (
    // @ts-ignore
    <ResponsiveLine
      {...params}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: true,
        reverse: false,
      }}
      axisTop={null}
      axisRight={null}
      curve="linear"
      lineWidth={3}
      pointSize={6}
      pointColor="white"
      pointBorderWidth={2}
      pointBorderColor={{ from: 'serieColor' }}
      enableArea
      areaOpacity={0.02}
      areaBlendMode="multiply"
      useMesh
      enableCrosshair={false}
      enableGridX={false}
      enableGridY
      theme={theme}
    />
  )
}
